export const INVOICE_TYPE_LIST_REQUEST = 'INVOICE_TYPE_LIST_REQUEST'
export const INVOICE_TYPE_LIST_SUCCESS = 'INVOICE_TYPE_LIST_SUCCESS'
export const INVOICE_TYPE_LIST_FAIL = 'INVOICE_TYPE_LIST_FAIL'
export const INVOICE_TYPE_LIST_RESET = 'INVOICE_TYPE_LIST_RESET'

export const INVOICE_TYPE_CREATE_REQUEST = 'INVOICE_TYPE_CREATE_REQUEST'
export const INVOICE_TYPE_CREATE_SUCCESS = 'INVOICE_TYPE_CREATE_SUCCESS'
export const INVOICE_TYPE_CREATE_FAIL = 'INVOICE_TYPE_CREATE_FAIL'

export const INVOICE_TYPE_GET_REQUEST = 'INVOICE_TYPE_GET_REQUEST'
export const INVOICE_TYPE_GET_SUCCESS = 'INVOICE_TYPE_GET_SUCCESS'
export const INVOICE_TYPE_GET_FAIL = 'INVOICE_TYPE_GET_FAIL'

export const INVOICE_TYPE_UPDATE_REQUEST = 'INVOICE_TYPE_UPDATE_REQUEST'
export const INVOICE_TYPE_UPDATE_SUCCESS = 'INVOICE_TYPE_UPDATE_SUCCESS'
export const INVOICE_TYPE_UPDATE_FAIL = 'INVOICE_TYPE_UPDATE_FAIL'

export const INVOICE_TYPE_DELETE_REQUEST = 'INVOICE_TYPE_DELETE_REQUEST'
export const INVOICE_TYPE_DELETE_SUCCESS = 'INVOICE_TYPE_DELETE_SUCCESS'
export const INVOICE_TYPE_DELETE_FAIL = 'INVOICE_TYPE_DELETE_FAIL'

